import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutubeRounded = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8122_35432)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M13.95 12L10.8 10.2V13.8L13.95 12Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM16.65 8.025C17.175 8.175 17.55 8.55 17.7 9.075C18 10.05 18 12 18 12C18 12 18 13.95 17.775 14.925C17.625 15.45 17.25 15.825 16.725 15.975C15.75 16.2 12 16.2 12 16.2C12 16.2 8.175 16.2 7.275 15.975C6.75 15.825 6.375 15.45 6.225 14.925C6 13.95 6 12 6 12C6 12 6 10.05 6.15 9.075C6.3 8.55 6.675 8.175 7.2 8.025C8.175 7.8 11.925 7.8 11.925 7.8C11.925 7.8 15.75 7.8 16.65 8.025Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8122_35432",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgYoutubeRounded;
